import "./style.scss";
import { useEffect, useState } from "react";
import { onlineApplicationsHeaderSelectConst } from "@/src/constants/applicationOnlineConsts";
import SelectDefault from "../../SelectDefault/SelectDefault";
import BtnDefault from "../../BtnDefault/BtnDefault";
import Refresh from "@/src/svg/header/Refresh";
import Archiv from "@/src/svg/header/Archiv";
import AddNew from "@/src/svg/header/AddNew";
import { setActualOfficeTable, setFilterStatus } from "@/src/store/slices/ApplicationPage/applicationsFiltersSlice";
import { useDispatch } from "react-redux";
import VerticalLine from "../../VerticalLine/VerticalLine";

const HeaderApplications = () => {
  const dispatch = useDispatch();
  const [currentOfficeSelect, setCurrentOfficeSelect] = useState<string>(onlineApplicationsHeaderSelectConst[0]?.title || "");
  const [isSelectChanged, setIsSelectChanged] = useState<boolean>(false);
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const handleChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentOfficeSelect(event.target.value);
    dispatch(setActualOfficeTable(event.target.value));
    dispatch(setFilterStatus("All"));
    setIsSelectChanged(true);
    setActiveTabIndex(0);
  };

  const handleEventRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="header-applications">
      <div className="header-bottom-select">
        <SelectDefault onChange={handleChangeEvent} value={currentOfficeSelect}>
          {onlineApplicationsHeaderSelectConst.map((item) => (
            <option value={item.id} key={item.id}>
              {item.title}
            </option>
          ))}
        </SelectDefault>
      </div>
      {/* <VerticalLine />
      <div className="header-bottom-tabs">
        {(isSelectChanged
          ? onlineApplicationsHeaderSelectConst.find((item) => item.id === currentOfficeSelect)?.mass
          : onlineApplicationsHeaderSelectConst[0]?.mass
        )?.map((tab, index) => (
          <div
            className={`header-bottom-tab ${index === activeTabIndex ? "active" : ""}`}
            key={index}
            onClick={() => setActiveTabIndex(index)}
          >
            <BtnDefault>
              <p>{tab.name}</p>
            </BtnDefault>
          </div>
        ))}
      </div> */}
      <div className="header-bottom-buttons">
        <BtnDefault onClick={handleEventRefresh}>
          <p>Refresh</p>
          <Refresh />
        </BtnDefault>
        <BtnDefault>
          <p>Archiv</p>
          <Archiv />
        </BtnDefault>
        <BtnDefault
          reverse={true}
          onClick={() => {
            const current = localStorage.getItem("applyOnlineApplications");
            if (current === "show") {
              localStorage.removeItem("applyOnlineApplications");
            } else {
              localStorage.setItem("applyOnlineApplications", "show");
            }
            window.dispatchEvent(new Event("applyOnlineApplicationsChanged"));
          }}
        >
          <p>Add new</p>
          <AddNew />
        </BtnDefault>
      </div>
    </div>
  );
};

export default HeaderApplications;
